<template>
    <div class="baoliaoContent scrollView" @scroll="elementScroll($event)">
        <a href="http://img2.yitoutiao.net/app/download.html">
            <img src="../assets/dianjibaoliao.png" style="width: 100%">
        </a>

        <div class="community-ask-warp report-list font-nomal"  v-if="data">
            <div class="community-list-head community-ask-header">
                <div class="community-list-head-left" @click.stop="tousercenter()" tapmode>
                    <div class="community-list-head-avatar">
                        <img v-lazy="data.head_img+'?x-oss-process=image/resize,m_lfit,h_100,w_100'"  class="community-list-head-avatar-img1">
                    </div>

                    <div class="community-list-head-account">
                        <div class="community-list-head-account-name">{{data.user_name}}</div>
                        <div class="community-list-head-account-info  font-nomal">
                            <span >{{data.ctime}}</span>
                        </div>
                    </div>

                </div>
            </div>



            <div class="community-ask-content-box" >
                <div class="community-ask-content font-nomal" v-html="data.content"></div>

                <!--多图-->
                <div class="community-list-imgs"  v-if="data.thumb && data.thumb.length>1" >
                    <img v-for="(item,index) in data.thumb" v-lazy="item+'?x-oss-process=image/resize,m_lfit,h_200,w_200'" @click.stop="videoImg(data,index)" tapmode>
                </div>
                <!--单图-->
                <div class="community-list-video" v-if="data.thumb && data.thumb.length ===1"  >
                    <img v-lazy="data.thumb[0]+'?x-oss-process=image/resize,m_lfit,h_400,w_750'">
                </div>
                <!--视频-->
                <!--视频-->
                <div v-for="video in data.video_path"  >
                    <div v-if="played == video.path" class="community-list-video" @click.stop ref="video_c">
                        <lay-video
                                    height="220"
                                    :poster="video.thumb"
                                    :src="video.path"></lay-video>
                    </div>
                    <div class="community-list-video"  @click.stop="playVideo(video.path)"  v-else>
                        <img v-lazy="video.thumb">
                        <div class="community-list-video-play">
                            <img src="../assets/minplay.svg" >
                        </div>
                    </div>
                </div>

                <div class="baoliao-item-replay" v-if="(data.comment_news && data.comment_news.length>0) || (data.praise && data.praise.length>0)">
                    <div class="baoliao-item-zhan" v-if="data.praise && data.praise.length>0">
                        <img v-for="img_i in data.praise" v-if="img_i.head_img" :src="img_i.head_img+'?x-oss-process=image/resize,m_lfit,w_60'">
                    </div>
                    <div class="baoliao-item-replay-line" v-if="data.comment_news && data.comment_news.length>0 && data.praise && data.praise.length>0"></div>
                    <div class="baoliao-item-replay-item1" v-for="r_item in data.comment_news"><span>{{r_item.user_name}}</span>:{{removeHtml(r_item.content)}}</div>

                </div>



            </div>



            <div class="default-video-item-bottom font-nomal"  tapmode>
                <div class="default-video-item-bottom-i">
                    <img src="../assets/icon_replay.png" >

                </div>
                <div class="default-video-item-bottom-line"></div>
                <div class="default-video-item-bottom-i">
                    <img src="../assets/baoliao_view.svg">
                    <span v-if="data.pv_num">{{data.pv_num}}</span>
                </div>

            </div>


        </div>










        <div class="ask-replay-item-head">
            <div></div>
            <span>事件回复</span>
        </div>

        <div class="ask-replay-item font-nomal" v-if="list" v-for="item in list">
            <div class="ask-replay-item-user"  >
                <img v-lazy="item.head_img">
                <span>{{item.user_name}}</span>
            </div>
            <div class="ask-replay-item-content" v-html="item.content"></div>

            <div class="ask-replay-item-bottom">
                <div>
                    {{item.create_time}}
                </div>

            </div>
        </div>


        <img src="../assets/baoliaobanner_big.jpg" style="width:100%" v-if="data">
<!--    <div style="width: 100%; height: 40px;"></div>-->

    </div>
</template>

<style>
    @import '../assets/css/listcomponentscss.css';
    .baoliaoContent {
        flex: 1
    }
    .baoliao-item-replay-item1{word-break: break-all; text-align: justify;color:#3e3e3e;margin-top: 5px;line-height: 22px;}

    .community-ask-header{ padding: 15px; margin-bottom: 0}
    .report-list .community-ask-content-box{ padding-top: 0}
    .report-list .community-ask-content{ font-weight:400;}
    .default-video-item-bottom{ height: 50px; display: flex; justify-content: space-between;align-items: center; font-size: 12px; color: #9d9494; padding: 0 15px;border-bottom: 5px solid #e9e9e9}
    .default-video-item-bottom>div{ display: flex; align-items: center}
    .default-video-item-bottom>div img{ height: 20px; margin-right: 4px}








    .ask-top{ border-bottom: 10px solid #f8f8f8; padding: 15px; padding-top: 20px;}
    .ask-content{ font-size: 20px; font-weight: bold; color: #323232}

    .ask-top-user{ display: flex; align-items: center; margin-top: 25px}
    .ask-top-user img{ width:24px; height: 24px; background-color: #d7d7d7; margin-right: 6px; border-radius: 50%}
    .ask-top-user div{ font-size: 10px; color: #9c9c9c}
    .ask-top-user .ask-top-user-name{ font-size: 14px; font-weight: bold}
    .ask-replay-item{ padding: 15px; border-bottom: 10px solid #f8f8f8;}
    .ask-replay-item-user{ height: fit-content; font-size: 14px; font-weight: bold; color: #9c9c9c; margin-bottom: 20px;
      align-items: center; display: flex}
    .ask-replay-item-user img{ background-color: #d7d7d7; width:30px; height: 30px; margin-right: 6px; border-radius: 50%}
    .ask-replay-item-content{ font-size: 16px; line-height: 24px; color: #464646; text-align: justify;}
    .ask-replay-item-content img{ border-radius: 4px; max-width: 80%; display: block; margin: auto}
    .ask-replay-item-content video{ max-width: 100%; max-height: 300px}
    .ask-replay-item-bottom{ display: flex; margin-top: 15px; justify-content: space-between; align-items: center;
      font-size: 14px; color: #9c9c9c; align-content: flex-end}
    .ask-replay-item-child{ margin-top: 20px}
    .ask-replay-item-child-title{ font-size: 18px; font-weight: bold; line-height: 30px; margin-bottom: 12px}
    .ask-replay-item-child-item{ display: flex; justify-content: space-between;margin-bottom: 20px}
    .ask-replay-item-child-item>img{ background-color: #d7d7d7; width:30px; height: 30px; margin-right: 6px; border-radius: 50% }
    .ask-replay-item-child-item>div{ flex: 1}
    .child-item-name{ font-size: 14px; font-weight: bold; color: #7c7c7c; line-height: 18px; margin-bottom: 2px}
    .child-item-date{ font-size: 12px; color: #9c9c9c; margin-bottom: 15px}
    .ask-replay-item-child-item-cont{ font-size: 16px; line-height: 26px;color: #464646; }
    .ask-replay-item-child-item-cont img{ max-width: 100% !important; display: block}
    .ask-replay-item-bottom-btns{ display: flex; align-items: center}
    .ask-replay-item-bottom-btns>div{ margin-left: 40px; font-size: 10px; color: #7c7c7c; font-weight: bold; display: flex; align-items: center;
      flex-direction: column;justify-content: center}
    .ask-replay-item-bottom-btns img{ height: 22px; }
    #app{ overflow: hidden}

    /*回复*/

    .ask-replay-item-head { padding-left: 15px; height: 60px; display: flex; align-items: center; font-size: 18px; font-weight: bold;    border-bottom:0.5px solid #e9e9e9;}
    .ask-replay-item-head div{ width: 4px; height: 20px; background-color: red; border-radius: 2px; margin-right: 5px}
    .minplay{ position: fixed; z-index: 10; display: flex; flex-direction: column; background-color: #fff; width: 100%; box-shadow: 0 0 10px rgba(0,0,0,0.1);
      left: 0; bottom:0; height: 300px;box-sizing: content-box; transform: translateY(110%); transition: 0.3s}
    .showMinReplay{transform: translateY(0); }
    .top{ height: 46px; padding-left: 15px; display: flex; align-items: center; justify-content: space-between; border-bottom: 0.3px solid rgba(0,0,0,0.3)}
    .top-close{ width: 50px; height: 50px; display: flex; justify-content: center; align-items: center}
    .top-close img{ height: 28px}
    .input{ display: flex; flex: 1; background-color: #f8f8f8;}
    .input textarea{ display: flex; width: 100%; height: 100%; padding: 15px; flex: 1; font-size: 16px; line-height: 26px; color: #323232;}
    .minplay-bottom{ height: 50px;  display: flex; align-items: center; justify-content: space-between; padding: 0 15px; font-size: 14px; color: #D2D6D9}
    .minplay-bottom div{ height: 32px; display: flex; align-items: center; padding: 0 20px; text-align: center;
      background-color: red; color: #fff; font-size: 14px; border-radius: 3px}
    ol li{
      list-style-type:decimal;
      list-style-position:inside;
    }
    .ask-replay-item-content video{ border-radius: 4px; background-color: #000}
    video{ width: 100%; display: inline-block}
    h2 {
      font-size: 20px;
      line-height: 32px;
      margin: 16px 0;
      position: relative;
    }

    h2:before {
      width: 16px;
      height: 26px;
      margin-right: 6px;
      background-image:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTk2MTkyNzQxNzMxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjUzMDYiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNOTEyLjcyNDg4NCA0MjkuMzU1NjgxTDIwOC43OTc1NDUgMTMuMTk4NjM4QzE1MS42MDM0NDktMjAuNTk3ODc0IDY0LjAxMjQ5IDEyLjE5ODc0MSA2NC4wMTI0OSA5NS43OTAxMTJWOTI3LjkwNDIxOWMwIDc0Ljk5MjI1OSA4MS4zOTE1OTkgMTIwLjE4NzU5NCAxNDQuNzg1MDU1IDgyLjU5MTQ3NWw3MDMuOTI3MzM5LTQxNS45NTcwNjRjNjIuNzkzNTE4LTM2Ljk5NjE4MSA2Mi45OTM0OTgtMTI4LjE4Njc2OCAwLTE2NS4xODI5NDl6IiBmaWxsPSIjRkY1RTVFIiBwLWlkPSI1MzA3Ij48L3BhdGg+PC9zdmc+');

      background-repeat: no-repeat;
      background-size: contain;
      background-position: center center;
      content: "";
      display: inline-block;
      vertical-align: middle;
      position: relative;
      top: -2px;
    }

    blockquote{    background-color: unset;
      padding: 0 16px;
      margin: 10px 0;
      color: #666;
      box-sizing: border-box;;
      position: relative;
      text-align: justify;

    }
    blockquote:before {
      content: " ";
      left: 0;
      position: absolute;
      width: 4px;
      height: calc(100% - 6px);
      margin-top: 3px;
      background: #d8d8d8;
    }


    /*爆料 fzlantin*/
    .baoliao-item{ padding: 15px; border-bottom: 0.5px solid #dddedf;color: #181818;
    }
    .baoliao-item-wrap{display: flex; }
    .baoliao-item-name{ font-family:fzlantin; font-size: 16px; margin-bottom: 10px; color: #586a92;}
    .baoliao-item-content{ font-size: 16px; line-height: 25px;font-family:fzlantin; font-weight: 100; letter-spacing:1.2px;text-align: justify;color: #282828; word-break: break-all;
    }
    .baoliao-item-content-box{padding:10px; background-color:#f7f7f7; border-radius: 4px; margin-bottom: 5px}
    .baoliao-item-replay-title{ font-size: 16px; font-weight: bold; margin-bottom: 10px; padding-bottom: 10px; display: flex; align-items: center;border-bottom: 1px dashed #c5c6c7
    }
    .baoliao-item-replay-title svg{ display: block; width: 15px; height: 15px; margin-left: 5px}

    .baoliao-item-avatar{ width: 40px; height: 40px; border-radius: 5px; overflow: hidden; background-color: #eeeff0
    }
    .baoliao-item-avatar-img{ width: 40px; height: 40px;}
    .baoliao-item-righ{ flex: 1; padding-left: 10px; max-width: 90%}
    .baoliao-item-bottom{ display: flex; justify-content: space-between; align-items: center; height: 24px; margin-bottom: 20px; padding-top: 10px}
    .baoliao-item-date{ font-size: 12px; color: #737373}
    .baoliao-item-replay{ background-color: #f2f2f2; font-size: 14px; line-height: 22px; padding: 10px; width: 100%;}

    .baoliao-item-replay-item1 span{ font-family:fzlantin;color: #5d6c8b;}
    .baoliao-item-replay-item{ word-break: break-all; text-align: justify;color:#3e3e3e;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical; margin-top: 5px;line-height: 22px;
    }
    .baoliao-item-img-one{ display: block; margin: 10px 0; max-width: 65%; max-height: 300px}

    .baoliao-item-control,.baoliao-item-control div{ display: flex; align-items: center}
    .baoliao-item-control div{ margin-left: 10px; font-size: 13px;color: #586a92;}
    .baoliao-item-control div svg{ width: 18px; height: 18px; margin-right: 2px}
    .baoliao-item-control div .icon2{width: 17px; height: 17px;}
    .baoliao-item-zhan{ margin-bottom: 3px;
    }
    .baoliao-item-zhan img{ display: inline-block; width: 34px; height: 34px;padding:1px;border-radius: 4px; overflow: hidden}
    .baoliao-item-replay-line{ width: 100%; height: 0.5px; background-color:  #c1c6cb}
</style>

<script>
    import layVideo from '@/components/Video.vue'



    import config from '../config'
    import utils from '../utils'
    import {ImagePreview, Toast} from 'vant';
    import request from "../utils/request";
    var $ = require("jquery");


    export default {
        name: 'Content',
        components: {
            layVideo
        },
        data() {
            return {
                id: this.$route.params.id,
                data: false,
                scrolltimer:false,
                lastscroll:0,
                scrollTopTimeOut:false,
                allow_run_scrollbottom:true,
              page:1,
              list:[],
                played:''
            }
        },

        created() {
            console.log(this.$route.params.id);
            this.getContent()
        },
        methods: {
            removeHtml:function(str){
                var regex = /(<([^>]+)>)/ig;
                str = str.replace(regex, "");
                str = str.replace(/\&nbsp\;/ig, "");
                return str
            },
            videoImg(data, index){
                if (!data.thumb) {
                    return;
                }

                ImagePreview({
                    images: data.thumb,
                    startPosition: index ? index : 0,
                });


            },
            playVideo(path) {
                this.played = path;
            },
            getContent() {
                $.get(config.NEWS_URL + '/v616.basics/info?s_id=' + this.id, (res) => {
                    if (res && res.code==200) {
                        this.data = res.data;

                        request.getWeixinShanre(location.href,(s_res)=>{
                            let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
                            let shareconfig = {appId,timestamp,nonceStr,signature};
                            if(utils.is_weixin()){
                                if(res.data.content){
                                    let sharedata = {
                                        title:'看度时政APP报料平台',
                                        desc:'【'+res.data.cat_name +'】'+utils.TextAreaText2Html(res.data.content),
                                        link:location.href,
                                        imgUrl:thumb
                                    };
                                    utils.setWeiXinShare(sharedata,shareconfig,true)
                                }

                            }
                        });

                    }else if(res.message){
                      Toast(res.message);
                    }
                    this.getReplayList()
                }, 'JSON')
            },
          elementScroll(e){

            //滚动到了底部
            if(this.scrollbottom){
              var topheight = e.target.offsetHeight + e.target.scrollTop;
              if((topheight+ this.bottomDistance) >= e.target.scrollHeight  && this.lastscroll<e.target.scrollTop){
                if(this.scrollTopTimeOut){
                  clearTimeout(this.scrollTopTimeOut);
                  this.scrollTopTimeOut = false;
                }


                if(this.allow_run_scrollbottom){
                  this.scrollbottom();
                  this.allow_run_scrollbottom = false;
                }


                this.scrollTopTimeOut = setTimeout(()=>{
                  this.allow_run_scrollbottom = true;
                },50);
              }
              this.lastscroll = e.target.scrollTop
            }

          },
          getReplayList(){
            let page = this.page;


              $.get(config.NEWS_URL + '/v616.basics/commentList?s_id=' + this.id + '&page=' + page, (res) => {


                  try{
                      if(res && res.code==200){
                          if(res.data.length<10){
                              this.showloading = false;
                              this.loadend = true
                          }
                          let list = this.list.concat(res.data);
                          this.list = utils.arrayDelRepeat(list,'c_id');
                          this.page ++;
                      }else if(res.message){
                          Toast(res.message);
                      }
                  }catch (e) {

                  }



              }, 'JSON')


          },
          scrollbottom(){
            this.getReplayList();
          },
        }
    }

</script>
